/**
 * Saved profile zone used for on-screen date-times.
 * Empty until sign-in loads a preference; callers then use the device zone.
 */

let savedZone: string | null = null;
let reportSeq = 0;
const listeners = new Set<() => void>();

export function beginDisplayTimeZoneReport(): number {
  reportSeq += 1;
  return reportSeq;
}

export function isCurrentDisplayTimeZoneReport(token: number): boolean {
  return token === reportSeq;
}

export function getDisplayTimeZone(): string | undefined {
  const zone = (
    savedZone ??
    Intl.DateTimeFormat().resolvedOptions().timeZone ??
    ''
  ).trim();
  return zone || undefined;
}

export function setDisplayTimeZone(timeZone: string | null): void {
  const next = timeZone?.trim() ? timeZone.trim() : null;
  if (next === null) {
    reportSeq += 1;
  }
  if (next === savedZone) {
    return;
  }
  savedZone = next;
  listeners.forEach(listener => listener());
}

export function subscribeDisplayTimeZone(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
